import { Action } from '@ngrx/store';
import { EffectsList } from '../constants/effects-list';

export const CREATE_EFFECTS_LIST = '[Effects] Create effects list';
export const LOAD_EFFECTS_LIST = '[Effects] Load effects list';

export class EffectsCreateListAction implements Action {
    readonly type = CREATE_EFFECTS_LIST;
}

export class EffectsLoadAction implements Action {
    readonly type = LOAD_EFFECTS_LIST;
    constructor(public payload: EffectsList) {}
}

export type EffecListActions =
    | EffectsLoadAction;
